// extracted by mini-css-extract-plugin
export var filterDropdown = "customerReviews-module--filterDropdown--9KMUV";
export var searchBar = "customerReviews-module--searchBar--HHnNH";